import React from 'react'
import * as MuiIcons from '@mui/icons-material'

export default ({ iconName, ...props }) => (
  <>{React.createElement(MuiIcons[iconName], { ...props })}</>
)
